import { Inject, Injectable } from '@angular/core';
import { API_URL } from '../../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { EntityTypes } from '../../entity/entity-types';
import { OfferItem } from './models/item';
import { OfferItemPayload } from './models/item-payload';
import { StoreBaseService } from '../../common/base.service';

@Injectable({
  providedIn: 'root'
})
export class OfferItemService
  extends StoreBaseService<OfferItem, OfferItemPayload> {

  get entityType(): string {
    return EntityTypes.offerItem;
  }

  get resourceName(): string {
    return 'offer-item';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }
}
